import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import Input from '../../common/Input'
import Checkbox from '../../common/Checkbox'

import * as Strings from './strings'

class LaundryModal extends Component {
  render() {
    const {
      show = true,
      hide,
      nameInput,
      outOfOrder,
      classes,
      header,
      information,
      onDone,
      onChangeNameInput,
      onChangeOutOfOrder,
      errorName,
      loading = false,
      errorMessage = ''
    } = this.props

    return (
      <Dialog open={show} aria-labelledby={'form-dialog-title'}>
        <DialogTitle id={'form-dialog-title'}>{header}</DialogTitle>
        <DialogContent>
          <DialogContentText>{information}</DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <Input
            placeholder={Strings.default.NAME + '*'}
            value={nameInput}
            onChange={text => onChangeNameInput(text)}
            error={errorName}
          />
          <Checkbox
            placeholder={Strings.default.OUT_OF_ORDER}
            checked={outOfOrder}
            onChange={checked => onChangeOutOfOrder(checked)}
            style={{ marginTop: 15 }}
          />
        </DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => hide()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => onDone()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

export default withStyles(Styles)(LaundryModal)



// WEBPACK FOOTER //
// ./src/components/common/LaundryModal/index.js